import styled from "styled-components"
import { GIVONIC, INTER } from "@styles/fonts"
import { BLACK, BLUE, BLUE_RIBBON_300, BLUE_RIBBON_700, DARK_VIOLET, GRAYSCALE_260, GRAYSCALE_800, NEUTRAL_100, PALE_BLUE, WHITE } from "@styles/colors"
import { FormattedText } from "@components/FormattedText/FormattedText"
import jagadLogoSoftUrl from '@assets/icons/JagadLogoSoft.svg'

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 1;
`

export const ContentContainer = styled.div`
  z-index: 3;
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  margin-top: 16px;
  justify-content: space-between;
  width: 100%;
`

export const PaddingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
  gap: 12px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-bottom: 24px;
`

export const TitleText = styled.span`
  font-family: ${GIVONIC.bold};
  color: ${BLUE_RIBBON_700};
  font-size: 24px;
  text-align: center;
`

export const ReferralCodeCard = styled.div`
  background-color: ${WHITE};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  border-width: 1px;
  border-color: ${NEUTRAL_100};
  border-style: solid;
  padding: 20px 16px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 -1px 20px rgba(96, 138, 222, 0.3);
`

export const CardTitle = styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_800};
  font-size: 13px;
`

export const CodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const CodeText = styled.span`
  font-family: ${INTER.semiBold};
  font-size: 18px;
  color: ${BLUE};
`

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background-color: ${PALE_BLUE};
  border: 1px solid ${NEUTRAL_100};
  border-radius: 8px;
  padding: 6px 2px 6px 12px;
  width: 100%;
`

export const LinkText = styled.span`
  font-family: ${INTER.medium};
  font-size: 13px;
  color: ${BLUE};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const IconContainer = styled.div<{
  $backgroundColor?: string
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  cursor: pointer;
  z-index: 3;
  background-color: ${({ $backgroundColor = 'transparent' }) => $backgroundColor};
`

export const DescriptionText = styled(FormattedText).attrs({
  style: {
    color: DARK_VIOLET,
    textAlign: 'center',
    width: '100%'
  }
})``

export const UsageContainer = styled.div`
  width: 100%;
  padding: 0 16px;
`

export const UsageBox = styled.div`
  border: 2px solid ${BLUE_RIBBON_300};
  padding: 16px;
  width: 100%;
  border-radius: 8px;
`

export const UsageText = styled.span`
  font-family: ${INTER.regular};
  color: ${BLACK};
`

export const BoldText = styled.span`
  font-family: ${INTER.semiBold};
`

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: ${WHITE};
`

export const StatColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
`

export const StatLabel = styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_800};
`

export const CurrencyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
`

export const AmountText = styled.span`
  font-family: ${INTER.bold};
  color: ${BLACK};
  font-size: 18px;
`

export const VerticalDivider = styled.div`
  align-self: stretch;
  width: 1px;
  background-color: ${NEUTRAL_100};
`

export const ReferralLinkCard = styled.div`
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  padding: 12px;
`

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  gap: 6px;
  margin: -6px;
`

export const LabelText = styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_800};
  font-size: 13px;
`

export const IconGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const BottomSection = styled.div`
  width: 100%;
  border-top: 1px solid ${NEUTRAL_100};
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  padding-top: 18px;
  gap: 12px;
`

export const JagadLogoSoft = styled.img.attrs({ src: jagadLogoSoftUrl })`
  position: absolute;
  right: -40px;
  top: -70px;
  z-index: 1;
`